import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TokenProvider } from "./context/TokenContext";
import { FalProvider } from "./context/FalContext";
import { useToken } from "./context/TokenContext";
import BottomNav from "./components/BottomNav";
import AnaSayfa from "./pages/AnaSayfa";
import Fallarim from "./pages/Fallarim";
import Falcilar from "./pages/Falcilar";
import Profil from "./pages/Profil";
import FalciProfil from "./pages/FalciProfil";
import FalYorum from "./pages/FalYorum";
import Reklam from "./pages/Reklam";
import TokenKazan from "./pages/TokenKazan";
import Giris from "./pages/Giris";
import FalDetay from "./pages/FalDetay";
import Onboarding from "./pages/Onboarding";
import Yasal from "./pages/Yasal";
import Numeroloji from "./pages/Numeroloji";
import Yildizname from "./pages/Yildizname";
import Tarot from "./pages/Tarot";
import Remil from "./pages/Remil";
import RemilNedir from "./pages/RemilNedir";
import OdemeSonuc from "./pages/OdemeSonuc";
import PaymentGate from "./pages/PaymentGate";
import RuyaTabiri from "./pages/RuyaTabiri";
import FaldaSemboller from "./pages/FaldaSemboller";
import RuyadaSemboller from "./pages/RuyadaSemboller";
import AuthCallback from "./pages/AuthCallback";

function KorunanRoute({ children }) {
  return children;
}

function GirisGerekli({ children }) {
  const { user, loading } = useToken();
  if (loading) return null;
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}

function AppIci() {
  const { user, loading } = useToken();

  if (loading) return (
    <div style={{
      minHeight: "100vh", background: "#0a0718",
      display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40,
    }}>
      🔮
    </div>
  );

  return (
    <>
      <Routes>
        <Route path="/onboarding" element={user ? <Navigate to="/" replace /> : <Onboarding />} />
        <Route path="/giris" element={user ? <Navigate to="/" replace /> : <Giris />} />

        <Route path="/" element={<KorunanRoute><AnaSayfa /></KorunanRoute>} />
        <Route path="/fallarim" element={<KorunanRoute><Fallarim /></KorunanRoute>} />
        <Route path="/falcilar" element={<KorunanRoute><Falcilar /></KorunanRoute>} />
        <Route path="/profil" element={<KorunanRoute><Profil /></KorunanRoute>} />
        <Route path="/falci/:id" element={<KorunanRoute><FalciProfil /></KorunanRoute>} />
        <Route path="/yasal/:tip" element={<KorunanRoute><Yasal /></KorunanRoute>} />
        <Route path="/numeroloji" element={<KorunanRoute><Numeroloji /></KorunanRoute>} />
        <Route path="/yildizname" element={<KorunanRoute><Yildizname /></KorunanRoute>} />
        <Route path="/tarot" element={<KorunanRoute><Tarot /></KorunanRoute>} />
        <Route path="/remil" element={<KorunanRoute><Remil /></KorunanRoute>} />
        <Route path="/remil-nedir" element={<KorunanRoute><RemilNedir /></KorunanRoute>} />
        <Route path="/ruya-tabiri" element={<KorunanRoute><RuyaTabiri /></KorunanRoute>} />
        <Route path="/falda-semboller" element={<KorunanRoute><FaldaSemboller /></KorunanRoute>} />
        <Route path="/ruya-semboller" element={<KorunanRoute><RuyadaSemboller /></KorunanRoute>} />
        <Route path="/buyu/*" element={<Navigate to="/" replace />} />

        <Route path="/fal/:falciId/:falTuru" element={<GirisGerekli><FalYorum /></GirisGerekli>} />
        <Route path="/token-satin" element={<Navigate to="/token-kazan" replace />} />
        <Route path="/token-kazan" element={<GirisGerekli><TokenKazan /></GirisGerekli>} />
        <Route path="/reklam" element={<Navigate to="/token-kazan" replace />} />
        <Route path="/odeme-sonuc" element={<OdemeSonuc />} />
        <Route path="/p/:token" element={<PaymentGate />} />
        <Route path="/fal-detay/:id" element={<GirisGerekli><FalDetay /></GirisGerekli>} />

        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
    </>
  );
}

export default function App() {
  return (
    <TokenProvider>
      <FalProvider>
        <BrowserRouter>
          <AppIci />
        </BrowserRouter>
      </FalProvider>
    </TokenProvider>
  );
}